export const latexKeys = [
  'validation.validResponse.value.value',
  'validation.altResponses.value.value',
  'validation.validResponse.mathUnits.value.value',
  'validation.altResponses.mathUnits.value.value',
]
